export const MAIN_PRODUCTION_HOST = 'forge.endure.network';
export const FORGE_DOC_URL = 'https://docs.forge.endure.network';
export const ENDURE_GITHUB_URL = 'https://github.com/Endure-Network/forge-lending';
export const FORGE_X_URL = 'https://x.com/endurenet';

export const VENUS_FLUX_URL = `https://${MAIN_PRODUCTION_HOST}`;
export const VENUS_DOC_URL = FORGE_DOC_URL;
export const VENUS_PRIME_DOC_URL = `${FORGE_DOC_URL}/whats-new/prime-yield`;

export const DISCORD_SERVER_URL = FORGE_X_URL;
